<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>


    <div class="form-edit-page">
        <form @submit.prevent="submitForm">
            <div class="row row-space">
                <div class="form-item" style="flex: 0 0 90px;">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ objEdicao.cdusuario }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Nome</label>
                    <input type="text" v-model="objEdicao.nmusuario" required maxlength="100" v-uppercase />
                </div>

                <div class="form-item" style="flex: 0 0 150px;">
                    <label class="label-caption">CPF</label>
                    <input type="text" class="input-center" v-model="objEdicao.cpf" v-cpf maxlength="14" />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item-telefone">
                    <label class="label-caption">Celular</label>
                    <input type="text" class="input-center" v-model="objEdicao.celular" v-phone maxlength="15" />
                </div>

                <div class="form-item-telefone">
                    <label class="label-caption">Fone</label>
                    <input type="text" class="input-center" v-model="objEdicao.fone" v-phone maxlength="15" />
                </div>

                <div class="form-item">
                    <label class="label-caption">Email</label>
                    <input type="email" v-model="objEdicao.email"/>
                </div>
                
                <div v-if="idEdicao==0" class="form-item-char20">
                    <label class="label-caption">Login Inicial</label>
                    <input type="text" v-model="objEdicao.login" />
                </div>

                <div v-if="idEdicao==0" class="form-item-char20">
                    <label class="label-caption">Senha Inicial</label>
                    <input type="text" v-model="objEdicao.senha" />
                </div>
            </div>     
            

            <div v-if="ckLoginAdmin" class="row-space">
                <div class="row-end">
                    <label for="ckativo">Ativo</label>
                    <input id="ckativo" type="checkbox" class="input-checkbox" v-model="ckAtivo" />
                </div>

                <div class="row-end">
                    <label for="ckadmin">Administrador do Sistema</label>
                    <input id="ckadmin" type="checkbox" class="input-checkbox" v-model="ckAdmin" />
                </div>
            </div>

            <div class="row-end">
                <button v-if="objEdicao.id>0" type="button" @click="showModalSenha=true">Alterar Login</button>
                <button type="submit" class="btn-confirm">Salvar</button>
                <button type="button" class="btn-cancel" @click="cancelForm">Cancelar</button>
            </div>            
        </form>
    </div>

    <div>
        <ModalRedefinirSenha
            :visible="showModalSenha"
            @update:visible="(value) => (showModalSenha = value)"
            @submit="redefinirLoginSenha" />
    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarUsuario } from '@/models/Usuario';
import { globalStore } from '@/globals';
import ModalRedefinirSenha from '@/components/modals/ModalRedefinirSenha.vue';


const emit=defineEmits(['close', 'salvo']);
const props=defineProps({idEdicao: {type: Number, default: 0}});

const ckAdmin = ref(false);
const ckAtivo = ref(false);
const ckLoginAdmin= ref(globalStore.ckadmin==='S');
const objEdicao = criarUsuario();
const isLoading = ref(false);
const showModalSenha = ref(false);

const cancelForm = () => {emit('close');}

const lerDados = async() => {
    if (props.idEdicao != 0) {
        try{
            isLoading.value = true;
            try{
                const req = await Api.getCadastroById('usuario', props.idEdicao);
                Object.assign(objEdicao, req[0]);
            }catch (error){console.error('Erro leitura dos dados', error);}
        }finally{isLoading.value = false;}
    }else{
        objEdicao.idmunicipio = globalStore.idmunicipio;
    }
    ckAdmin.value         = objEdicao.ckadmin === 'S';
    ckAtivo.value         = objEdicao.ckativo === 'S';
    objEdicao.idusuario   = globalStore.idusuario;
};

const redefinirLoginSenha = async({username, senha}) => {
    try{
        isLoading.value = true;
        const r = await Api.genericPut('/cad/usuario', {id: objEdicao.id, login: username, senha: senha});
        if (r.bolok == 1){
            alert("Nova senha alterada com sucesso");
            objEdicao.login = username;  // POR GARANTIA ATÉ QUE DESVINCULE LOGIN E SENHA DO OBJETO
            objEdicao.senha = senha;
        }else{alert(r.error);}
    }finally {isLoading.value = false;}
}

const submitForm = async() => {
    try{
        objEdicao.ckativo       = ckAtivo.value ? 'S' : 'N';
        objEdicao.ckadmin       = ckAdmin.value ? 'S' : 'N';
        const response        = await Api.genericPut('/cad/usuario', objEdicao);
        if (response.bolok == 1){
            emit('salvo');
            emit('close');
        }else{alert(response.erro);}
    }catch (error){console.error('Error:', error);}
}

onMounted(lerDados)
</script>